import apiClient from "../core/HttpClient";
import { CharityIssue } from "../models";

export default class CharityIssueService{
    url="/CharityIssues";

    public async getCharityIssues(): Promise<CharityIssue[]> {
        return await apiClient.get(this.url).then((res) => res.data);
    }

    public async getCharityIssue(id: string): Promise<CharityIssue> {
        return await apiClient.get(`${this.url}/${id}`).then((res) => res.data);
    }

    public async createCharityIssue(charityIssue: CharityIssue) {
        return await apiClient.post(this.url, charityIssue);
    }

    public async updateCharityIssue(charityIssue: CharityIssue) {
        return await apiClient.put(`${this.url}/${charityIssue.id}`, charityIssue);
    }

    public async deleteCharityIssue(id: number): Promise<void> {
        await apiClient.delete(`${this.url}/${id}`);
    }
    
}
